import React, { useEffect, useState } from 'react';
import { back, chevron_right, expand, gear } from '../../Images/Icons';
import { useNavigate, useParams } from 'react-router-dom';
import { View } from '../../Components';
import EnvironmentalCard from '../HomePage/EnvironmentalCard';
import YieldSection from './YieldSection';
import ConsumptionSection from './ConsumptionSection';
import ChartSection from './ChartSection';
import RevenueSection from './RevenueSection';
import CoachMarkStep8 from '../../Components/CoachMark/Step8';
import { nextStep,backStep } from "../../Var/CoachmarkVar";
import { useSelector, useDispatch } from 'react-redux';

import { DatePicker } from 'rsuite';
import 'rsuite/DatePicker/styles/index.css';
import { GetDataEnvirontment } from '../../Services/HomeServices';
import { GetDataStatisticHourly, GetDataStatisticLifeTime, GetDataStatisticMonth, GetDataStatisticMonthByDay, GetDataStatisticYear, GetElecticPrice } from '../../Services/StatisticServices';
import css from './statistic.module.scss';
import { isBefore, isAfter, parseISO } from 'date-fns';
import { be } from 'date-fns/locale';

const selectedCss = {
    background: 'white', color: '#161616', fontWeight: 500
};

const StatisticPage = () => {
    const navigation = useNavigate(); 
    const station_get = localStorage.getItem("station_get");
    const start_date = localStorage.getItem("start_date");
    const coachmark = localStorage.getItem("coachmark");
    // alert(start_date)
    const Step = useSelector(state => state.Step)
    
    const [from_pv, setFromPV] = useState([]);
    const [total_consumption, setTotalConsumption] = useState([]);
    const [battery_charge, setBatteryCharge] = useState([]);
    const [battery_discharge, setBatteryDischarge] = useState([]);
    const [revenue, setRevenue] = useState([]);
    const [legend, setLegend] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [Loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    
    const [dataEnv, setDataEnv] = useState(null);

    const [state, setAllState] = useState({
        selectedTab: 1,
        sum_total_consumption: 1.50,
        consumptionLabel: 'this month',
        EMConsumed : 0,
        fed_to_grid: 0,
        SelfSuff: 0,
        FromGrid: 0,
        Sum_Revenue: 0
    });

    const setState = data => {
        setAllState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => {
        navigation(-1);
    }

    async function GetStatistic() {
        
        const price_db = await GetElecticPrice(atob(station_get), data);
        let price = price_db.data.electricity_price;

        if(selectedTab == 0){
            setLoading(true)
            let from_pv = [];
            let total_consumption = [];
            let battery_charge = [];
            let battery_discharge = [];
            let legend = [];
            let revenue = [];
            let sum_total_consumption = 0;
            let EMConsumed = 0;
            let fed_to_grid = 0;
            let SelfSuff = 0;
            let FromGrid = 0;
            let Sum_Revenue = 0;

            try {  
                var data = new FormData();        
                const formattedDate = new Date(selectedDate).toISOString().slice(0, 10);
                data.append("date", formattedDate);
                const resultStation = await GetDataStatisticHourly(atob(station_get), data);
                const resultSumarry = await GetDataStatisticMonthByDay(atob(station_get), data);
                setLoading(false)

                for (const item of resultStation.data) {
                    sum_total_consumption += item.total_consumption;
                    EMConsumed += item.consumed;
                    fed_to_grid += item.fed_to_grid;
                    SelfSuff += item.self_sufficiency_data;
                    FromGrid += item.from_grid;
                    Sum_Revenue += item.pv_output * price;

                    from_pv.push(parseFloat(parseFloat(item.consumed_from_pv).toFixed(2)));
                    total_consumption.push(parseFloat(parseFloat(item.total_consumption).toFixed(2)));
                    battery_charge.push(parseFloat(item.battery_charge.toFixed(2)));
                    battery_discharge.push(parseFloat(item.battery_discharge.toFixed(2)));
                    
                    
                    const totalRevenue = item.pv_output * price
                    revenue.push(parseInt(totalRevenue.toFixed(0)));

                    const convertData = new Date(item.created_at);
                    const hours = convertData.getHours();
                    const minutes = convertData.getMinutes();
                    // Formatting the time as HH:MM
                    const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    legend.push(time);
                    
                }
                localStorage.setItem("revenue_today", Sum_Revenue);
                localStorage.setItem("total_consumption", resultSumarry.data[0].total_consumption);
                setLegend(legend)
                setFromPV(from_pv)
                setTotalConsumption(total_consumption)
                setBatteryCharge(battery_charge)
                setBatteryDischarge(battery_discharge)
                setRevenue(revenue)
                console.log('revenue 2',revenue)
                setState({ 
                    sum_total_consumption: resultSumarry.data[0].total_consumption,
                    EMConsumed: resultSumarry.data[0].consumed,
                    fed_to_grid: resultSumarry.data[0].fed_to_grid,
                    SelfSuff: resultSumarry.data[0].self_sufficiency_data,
                    FromGrid: resultSumarry.data[0].from_grid,
                    Sum_Revenue: Sum_Revenue
                });
            } catch (error) {
                console.error('Error fetching dataStation:', error);
            }
        }else if(selectedTab == 1){
            
            let from_pv = [];
            let total_consumption = [];
            let battery_charge = [];
            let battery_discharge = [];
            let revenue = [];
            let legend = [];
            let sum_total_consumption = 0;
            let EMConsumed = 0;
            let fed_to_grid = 0;
            let SelfSuff = 0;
            let FromGrid = 0;
            let Sum_Revenue = 0;
            // alert()
            

            try {  
                var data = new FormData();
                data.append("date", new Date(selectedDate).toISOString().split('T')[0]);
                const resultStation = await GetDataStatisticMonth(atob(station_get), data);
                // console.log(price_db.data.electricity_price)

                for (const item of resultStation.data) {
                    sum_total_consumption += item.total_consumption;
                    EMConsumed += item.consumed;
                    fed_to_grid += item.fed_to_grid;
                    SelfSuff += item.self_sufficiency_data;
                    FromGrid += item.from_grid;
                    Sum_Revenue += (item.from_pv * price);
                    from_pv.push(parseFloat(item.from_pv).toFixed(2));
                    total_consumption.push(parseFloat(item.total_consumption).toFixed(2));
                    battery_charge.push(parseFloat(item.battery_charge).toFixed(2));
                    battery_discharge.push(parseFloat(item.battery_discharge).toFixed(2));
                    
                    
                    const totalRevenue = item.from_pv * price
                    revenue.push(parseInt(totalRevenue.toFixed(0)));

                    const convertData = new Date(item.cutOff_id);
                    legend.push(convertData.getDate());
                }

                setLegend(legend)
                setFromPV(from_pv)
                setTotalConsumption(total_consumption)
                setBatteryCharge(battery_charge)
                setBatteryDischarge(battery_discharge)
                setRevenue(revenue)
                setState({ 
                    sum_total_consumption: sum_total_consumption,
                    EMConsumed: EMConsumed,
                    fed_to_grid: fed_to_grid,
                    SelfSuff: SelfSuff,
                    FromGrid: FromGrid,
                    Sum_Revenue: Sum_Revenue
                });
            } catch (error) {
                console.error('Error fetching dataStation:', error);
            }
        }else if(selectedTab == 2){
            
            let from_pv = [];
            let total_consumption = [];
            let battery_charge = [];
            let battery_discharge = [];
            let revenue = [];
            let legend = [];
            let sum_total_consumption = 0;
            let EMConsumed = 0;
            let fed_to_grid = 0;
            let SelfSuff = 0;
            let FromGrid = 0;
            let Sum_Revenue = 0;
            try {  
                var data = new FormData();
                data.append("date", new Date(selectedDate).toISOString().split('T')[0]);
                const resultStation = await GetDataStatisticYear(atob(station_get), data);

                for (const item of resultStation.data) {
                    sum_total_consumption += item.total_consumption;
                    EMConsumed += item.consumed;
                    fed_to_grid += item.fed_to_grid;
                    SelfSuff += item.self_sufficiency_data;
                    FromGrid += item.from_grid;
                    // Sum_Revenue += item.revenue;
                    Sum_Revenue += (item.from_pv * price);

                    from_pv.push(parseFloat(item.total_yield));
                    total_consumption.push(parseFloat(item.total_consumption.toFixed(2)));
                    battery_charge.push(parseFloat(item.battery_charge.toFixed(2)));
                    battery_discharge.push(parseFloat(item.battery_discharge.toFixed(2)));

                    const totalRevenue = item.from_pv * price
                    revenue.push(parseInt(totalRevenue.toFixed(0)));
                    // revenue.push(parseFloat(item.revenue.toFixed(2)));
                    
                    legend.push(item.month_data);
                    
                }
                setLegend(legend)
                setFromPV(from_pv)
                setTotalConsumption(total_consumption)
                setBatteryCharge(battery_charge)
                setBatteryDischarge(battery_discharge)
                setRevenue(revenue)
                setState({ 
                    sum_total_consumption: sum_total_consumption,
                    EMConsumed: EMConsumed,
                    fed_to_grid: fed_to_grid,
                    SelfSuff: SelfSuff,
                    FromGrid: FromGrid,
                    Sum_Revenue: Sum_Revenue
                });
            } catch (error) {
                console.error('Error fetching dataStation:', error);
            }
        }else if(selectedTab == 3){
            
            let from_pv3 = [];
            let total_consumption3 = [];
            let battery_charge3 = [];
            let battery_discharge3 = [];
            let revenue3 = [];
            let legend = [];
            let sum_total_consumption3 = 0;
            let EMConsumed3 = 0;
            let fed_to_grid3 = 0;
            let SelfSuff3 = 0;
            let FromGrid3 = 0;
            let Sum_Revenue3 = 0;
            try {  
                var data = new FormData();
                data.append("date", new Date(selectedDate).toISOString().split('T')[0]);
                const resultStation = await GetDataStatisticLifeTime(atob(station_get), data);
                console.log(resultStation.data)
                for (const item of resultStation.data) {
                    sum_total_consumption3 += item.total_consumption;
                    EMConsumed3 += item.consumed;
                    fed_to_grid3 += item.fed_to_grid;
                    SelfSuff3 += item.self_sufficiency_data;
                    FromGrid3 += item.from_grid;
                    Sum_Revenue3 += item.from_pv * price;
                    from_pv3.push(parseFloat(item.from_pv.toFixed(2)));
                    total_consumption3.push(parseFloat(item.total_consumption.toFixed(2)));
                    battery_charge3.push(parseFloat(item.battery_charge.toFixed(2)));
                    battery_discharge3.push(parseFloat(item.battery_discharge.toFixed(2)));
                    
                    const totalRevenue = item.from_pv * price
                    revenue3.push(parseInt(totalRevenue.toFixed(0)));

                    legend.push(item.year_data);
                    
                }
                setLegend(legend)
                setFromPV(from_pv3)
                setTotalConsumption(total_consumption3)
                setBatteryCharge(battery_charge3)
                setBatteryDischarge(battery_discharge3)
                setRevenue(revenue3)
                setState({ 
                    sum_total_consumption: sum_total_consumption3,
                    EMConsumed: EMConsumed3,
                    fed_to_grid: fed_to_grid3,
                    SelfSuff: SelfSuff3,
                    FromGrid: FromGrid3,
                    Sum_Revenue: Sum_Revenue3
                });
            } catch (error) {
                console.error('Error fetching dataStation:', error);
            }
        } else {
            
            setFromPV([])
            setTotalConsumption([])
            setBatteryCharge([])
            setBatteryDischarge([])
            setRevenue([])
            setState({ 
                sum_total_consumption: 0,
                EMConsumed: 0,
                fed_to_grid: 0,
                SelfSuff: 0,
                FromGrid: 0,
                Sum_Revenue: 0
            });
        }
    }
    


    const onTabClick = (index) => () => {
        setSelectedDate(new Date());
        setFromPV([])
        setTotalConsumption([])
        setBatteryCharge([])
        setBatteryDischarge([])
        setRevenue([])
        setState({ 
            sum_total_consumption: 0,
            EMConsumed: 0,
            fed_to_grid: 0,
            SelfSuff: 0,
            FromGrid: 0,
            Sum_Revenue: 0
        });
        if (index == 0) {
            setState({ selectedTab: index, sum_total_consumption: sum_total_consumption, consumptionLabel: 'today' });
        } else if (index == 1) {
            setState({ selectedTab: index, sum_total_consumption: 0, consumptionLabel: 'this month' });
        } else if (index == 2) {
            setState({ selectedTab: index, sum_total_consumption: 0, consumptionLabel: 'this year' });
        } else if (index == 3) {
            setState({ selectedTab: index, sum_total_consumption: 0, consumptionLabel: 'Lifetime' });
        }

    }

    const { selectedTab, sum_total_consumption, consumptionLabel, EMConsumed, fed_to_grid, SelfSuff, FromGrid, Sum_Revenue } = state;

    const doNextStep = () => {
        dispatch(
            nextStep(1)
        )
    };
    const doBackStep = () => {
        dispatch(
            backStep(1)
        )
    };

    

    async function GetDataAll() {
        try {
            const resultEnv = await GetDataEnvirontment(station_get);
            setDataEnv(resultEnv.data);

        } catch (error) {
          console.error('Error fetching dataStation:', error);
        }
    }

    


    useEffect(() => {
        

        GetDataAll()
        GetStatistic()

    }, [selectedTab, selectedDate]);

    
    if (!dataEnv || Loading == true) {
        return <div className='loading-state-statistic'>
            <div className='loader-z'></div>
        </div>;
    }


    //  Filter Setting
    function changeDateFormat(dateString) {
        const parts = dateString.split('-');
        if (parts.length === 3) {
          return `${parts[0]}-${parts[2]}-${parts[1]}`;
        } else {
          return dateString;
        }
    }

    
    const beforeDateISO = changeDateFormat(start_date);
    const afterDateISO = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0];
    const nowDateISO = new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0];

    
    const shouldDisableDate = (date) => {
      const beforeDate = parseISO(beforeDateISO);
      const afterDate = parseISO(afterDateISO);
        // alert(beforeDate, afterDate)
      return isBefore(date, beforeDate) || isAfter(date, afterDate);
    };

    const handleDateChange = (days, type) => {
        let newDate = new Date(selectedDate);
        
            


        
        if(type == 'date'){
            newDate.setDate(newDate.getDate() + days);
        }else if(type == 'month'){
            newDate.setMonth(newDate.getMonth() + days);
        }else if(type == 'year'){
            newDate.setDate(newDate.getDate() + days);
        }else if(type == 'lifetime'){
            newDate.setDate(newDate.getDate() + days);
        }
        setSelectedDate(newDate);
    };
    
    const handleChange = (value, event) => {
        setSelectedDate(value);
    };

    // End setting

    return (
        <div>
            {Step.coachmark == 8  && coachmark == 'false' && <CoachMarkStep8 next={doNextStep} prev={doBackStep} />}

            <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Statistic</div>
                </div>
            </div>
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1, background: '#F2F5FA' }}>
                <div>
                    <div style={{ margin: 20, background: 'white', borderRadius: 12, padding: 12 }}>
                        {Step.coachmark != 8 && 
                            <>
                                {/* Real Data */}
                                <div style={{ height: 33, padding: 4, borderRadius: 24, background: '#F2F5FA' }}>
                                    <View justifyContent="space-evenly" style={{ padding: '0 12px' }}>
                                        <div onClick={onTabClick(0)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 0 ? selectedCss : {})
                                        }}>Day</div>
                                        <div onClick={onTabClick(1)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 1 ? selectedCss : {})
                                        }}>Month</div>
                                        <div onClick={onTabClick(2)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 2 ? selectedCss : {})
                                        }}>Year</div>
                                        <div onClick={onTabClick(3)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 3 ? selectedCss : {})
                                        }}>Lifetime</div>
                                    </View>
                                </div>

                                <div style={{ height: 65, marginTop: 20, padding: 4, textAlign: 'center', borderRadius: 12, background: '#F2F5FA' }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: '#161616', marginTop: 6 }}>{parseInt(sum_total_consumption)} <span style={{ fontSize: 12, fontWeight: 500, color: '#6d6d6d' }}>kWh</span></div>
                                    <div style={{ fontSize: 12, fontWeight: 500, color: '#6d6d6d' }}>Consumption {consumptionLabel}</div>
                                </div>
                            
                                {/** Date Range */}
                                <div style={{ height: 60, marginTop: 20 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position:'relative' }}>
                                        {selectedTab == 0 &&
                                            <>
                                                {beforeDateISO != selectedDate.toISOString().split('T')[0] ?
                                                    <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} onClick={() => handleDateChange(-1,'date')}/> </div>
                                                : 
                                                    <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} className='gray-image' style={{ transform: 'rotate(180deg)' }} /> </div>
                                                }
                                            </>
                                        }
                                        {selectedTab == 1 &&
                                            <>
                                                {parseISO(beforeDateISO).getMonth() + 1 != selectedDate.getMonth() + 1 ? 
                                                    <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} onClick={() => handleDateChange(-1,'month')}/> </div>
                                                    : 
                                                    <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} className='gray-image'/> </div>
                                                }
                                            </>
                                        }
                                        {selectedTab == 2 &&
                                            <>
                                            {/* <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} onClick={() => handleDateChange(-1,'year')}/> </div> */}
                                            <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} className='gray-image'/> </div>
                                            </>
                                        }
                                        {selectedTab == 3 &&
                                            // <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} onClick={() => handleDateChange(-1,'lifetime')}/> </div>
                                            <div style={{ width: 30, textAlign: 'center', cursor: 'pointer' }}><img src={chevron_right} style={{ transform: 'rotate(180deg)' }} className='gray-image'/> </div>
                                        }
                                        <div style={{ display: 'flex', fontSize: 14, fontWeight: 500, color: 'black', cursor: 'pointer', position:'relative' }}>
                                            
                                             {selectedTab == 0 && <DatePicker oneTap style={{ width: 200, position:'relative' }} format="dd/MM/yyyy" value={selectedDate} shouldDisableDate={shouldDisableDate} onOpenChange={true} onChange={handleChange}  /> }
                                             {selectedTab == 1 && <DatePicker oneTap style={{ width: 200, position:'relative' }} format="MM/yyyy" value={selectedDate} shouldDisableDate={shouldDisableDate} onOpenChange={true} onChange={handleChange} /> }
                                             {selectedTab == 2 && 
                                                <select className={css.year}>
                                                    <option value="2024" selected>2024</option>
                                                </select>
                                             }
                                             {selectedTab == 3 && 
                                                <select className={css.year}>
                                                    <option value="2024" selected>2024</option>
                                                </select>
                                             }
                                             {selectedTab == 0 || selectedTab == 1 ?
                                                <span span className='fi fi-rr-caret-down' style={{ fontSize: 18, marginLeft: -45, position:'relative', marginTop:2 }}></span>
                                                :
                                                <span span className='fi fi-rr-caret-down' style={{ fontSize: 18, marginLeft: -20, position:'relative', marginTop:3 }}></span>
                                             }
                                        </div>


                                        {selectedTab == 0 &&
                                            <>
                                                {nowDateISO != selectedDate.toISOString().split('T')[0] ?
                                                    <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right} onClick={() => handleDateChange(1,'date')} /> </div>
                                                :
                                                    <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right} className='gray-image'/> </div>
                                                
                                                }
                                            </>
                                        }
                                        {selectedTab == 1 &&
                                        <>
                                            {parseISO(beforeDateISO).getMonth()  != selectedDate.getMonth() + 1 ? 
                                                <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right} onClick={() => handleDateChange(1,'month')} /> </div>
                                            :
                                                <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right} className='gray-image' /> </div>
                                            }    
                                            {/* {parseISO(beforeDateISO).getMonth() + 1}
                                            {selectedDate.getMonth() + 1} */}
                                        </>
                                        }
                                        {selectedTab == 2 &&
                                            // <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right}  className='gray-image' onClick={() => handleDateChange(1,'year')} /> </div>
                                            <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right}  className='gray-image' /> </div>
                                        }
                                        {selectedTab == 3 &&
                                            // <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right}  className='gray-image' onClick={() => handleDateChange(1,'lifetime')} /> </div>
                                            <div style={{ width: 30, textAlign: 'center', cursor: 'pointer', marginTop:0 }}><img src={chevron_right}  className='gray-image' /> </div>
                                        }
                                    </div>
                                </div>
                            </>
                        }

                        {Step.coachmark == 8 && 
                            <>
                                {/* Real Data */}
                                <div style={{ height: 33, padding: 4, borderRadius: 24, background: '#F2F5FA',  marginBottom:10 }}>
                                    <View justifyContent="space-evenly" style={{ padding: '0 12px' }}>
                                        <div onClick={onTabClick(0)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 500, cursor: 'pointer', ...(selectedTab == 0 ? selectedCss : {})
                                        }}>Day</div>
                                        <div onClick={onTabClick(1)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 1 ? selectedCss : {})
                                        }}>Month</div>
                                        <div onClick={onTabClick(2)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 2 ? selectedCss : {})
                                        }}>Year</div>
                                        <div onClick={onTabClick(3)} style={{
                                            width: 62, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center',
                                            borderRadius: 24, fontSize: 14, fontWeight: 400, color: '#787E88', cursor: 'pointer', ...(selectedTab == 3 ? selectedCss : {})
                                        }}>Lifetime</div>
                                    </View>
                                </div>

                            </>
                        }

                        {/* Energy Management */}
                        <div style={{}}>
                            <div style={{ fontSize: 16, fontWeight: 500, color: '#161616', textAlign: 'center' }}>Energy Management</div>

                            {/*yield*/}
                            <YieldSection state={state} />

                            {/*consumption*/}
                            <ConsumptionSection state={state} />

                            {/*Chart*/}
                            {from_pv && 
                                <ChartSection from_pv={from_pv} total_consumption={total_consumption} battery_charge={battery_charge} battery_discharge={battery_discharge} legend={legend} selectedTab={selectedTab} />
                            }
                            {Loading && 'Loading'}

                        </div>
                    </div>
                    

                    {/*Revenue*/}
                    <RevenueSection state={state} revenue={revenue} legend={legend} />
                    

                    { /* Environmental Benefits */}
                    <div style={{ margin: 20, background: 'white', borderRadius: 12 }}>
                        <EnvironmentalCard dataEnv = {dataEnv} />
                    </div>


                </div>
            </div>
            
        </div>
    )
}

export default StatisticPage